import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { buildSocialNetworkPatchPayload } from '@/helpers/functions/socialCaptionFlux'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    tonsIa: [],
    listDataInitialByJob: [],
    librariePrompt: {
      count: 0,
      prompts: []
    },
    prompt: {
      annonceurId: 0,
      defaut: false,
      diffuseurId: -1,
      datum: null,
      contraintes: null,
      miseEnFormes: null,
      id: null,
      prompt: '',
      reseau: null,
      temperature: 0.1,
      titre: '',
      ton: ''
    },
    infos: {
      annonceurId: null,
      diffuseurId: null
    },
    mode: null,
    loadingPromptSimulate: false,
    promptSimulate: null
  },
  getters: {
    getTonsIa: (state) => state.tonsIa,
    getListDataInitialByJob: (state) => state.listDataInitialByJob,
    getLibrariePrompt: (state) => state.librariePrompt.prompts,
    getPrompt: (state) => state.prompt,
    getCountAllPrompts: (state) => state.librariePrompt.count,
    getIsLoading: (state) => state.isLoading,
    getLoadingPromptSimulate: (state) => state.loadingPromptSimulate,
    getPromptSimulate: (state) => state.promptSimulate
  },
  mutations: {
    setTonsIa (state, data) {
      state.tonsIa = data
    },
    setLoadingPrompt (state, bool) {
      state.isLoading = bool
    },
    setListDataInitialByJob (state, data) {
      state.listDataInitialByJob = data
    },
    addOrUpdateLibrary (state, prompt) {
      const indexPrompt = state.librariePrompt.prompts.findIndex((item) => item.id === prompt.id)
      if (indexPrompt === -1) {
        state.librariePrompt.prompts.unshift(prompt)
      } else {
        state.librariePrompt.prompts[indexPrompt] = prompt
      }
    },
    resetLibrariePrompts (state, data) {
      state.librariePrompt.prompts = data.prompts
      state.librariePrompt.count = data.count
    },
    deletedPrompt (state, prompt) {
      const librariePrompt = state.librariePrompt.prompts
      const index = librariePrompt.indexOf(prompt)
      if (index > -1) {
        state.librariePrompt.prompts.splice(index, 1)
      }
    },
    setPrompt (state, prompt) {
      state.prompt = prompt
    },
    setDonnees (state, checkedData) {
      const selectedDonnees = state.listDataInitialByJob.filter((donnee) => checkedData.includes(donnee.libelle))

      // Si datum n'existe pas, le créer
      if (!state.prompt.datum) {
        state.prompt.datum = { id: null, champs: [] }
      }

      // Modifier seulement le tableau champs, préserver l'objet datum
      state.prompt.datum.champs = selectedDonnees
    },
    addDonnee (state, donnee) {
      // Si datum n'existe pas, le créer
      if (!state.prompt.datum) {
        state.prompt.datum = { id: null, champs: [] }
      }

      // Ajouter une donnée si elle n'existe pas déjà
      const exists = state.prompt.datum.champs.find(item => item.id === donnee.id)
      if (!exists) {
        state.prompt.datum.champs.push(donnee)
      }
    },
    removeDonnee (state, donneeId) {
      // Si datum existe, supprimer la donnée
      if (state.prompt.datum && state.prompt.datum.champs) {
        const index = state.prompt.datum.champs.findIndex(item => item.id === donneeId)
        if (index > -1) {
          state.prompt.datum.champs.splice(index, 1)
        }
      }
    },
    setAnnonceurId (state, annonceurId) {
      state.prompt.annonceurId = annonceurId
    },
    setMode (state, mode) {
      state.mode = mode
    },
    resetPrompt (state) {
      state.prompt = {
        annonceurId: 0,
        defaut: 0,
        diffuseurId: -1,
        datum: null,
        contraintes: null,
        miseEnFormes: null,
        id: null,
        prompt: '',
        reseau: null,
        temperature: 0.1,
        titre: '',
        ton: ''
      }
      state.promptSimulate = ''
    },
    setInfos (state, { annonceurId, diffuseurId }) {
      state.infos.annonceurId = annonceurId
      state.infos.diffuseurId = diffuseurId
    },
    setLoadingPromptSimulate (state, bool) {
      state.loadingPromptSimulate = bool
    },
    setPromptSimulate (state, promptSimulate) {
      state.promptSimulate = promptSimulate
    }
  },
  actions: {
    loadTonsIa (context) {
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/v2/tons-ia')
        .then((response) => {
          context.commit('setTonsIa', response.data)
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement des tons IA:', error.message)
          }
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
        })
    },
    loadListDataInitialByJob (context) {
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/donnees-annonceurs')
        .then((response) => {
          context.commit('setListDataInitialByJob', response.data)
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement des données initiales:', error.message)
          }
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
        })
    },
    loadPrompts ({ commit, rootState }) {
      const sitimmoUser = rootState.app.sitimmoUser
      commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get(`/v2/get-prompts?annonceurId=${sitimmoUser.id}&tri[direction]=asc&tri[sort]=id`)
        .then((response) => {
          const data = response.data
          if (data.count > 0) {
            const result = { count: data.count, prompts: data.prompts }
            commit('resetLibrariePrompts', result)
          }
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement des prompts:', error.message)
          }
        }).finally(() => {
          commit('setLoadingPrompt', false)
        })
    },
    callSimulate (context) {
      context.state.promptSimulate = null
      context.commit('setLoadingPromptSimulate', true)
      const currentPrompt = context.state.prompt
      const newSimulatePrompt = {
        annonceurId: currentPrompt.annonceurId,
        diffuseurId: null,
        mode: context.state.mode,
        persona: '',
        prompt: {
          id: currentPrompt.id,
          diffuseurId: -1,
          defaut: currentPrompt.defaut,
          datum: currentPrompt.datum,
          contraintes: currentPrompt.contraintes,
          miseEnFormes: currentPrompt.miseEnFormes,
          reseau: null,
          temperature: 0.1,
          titre: currentPrompt.titre,
          ton: currentPrompt.ton
        }
      }
      HTTP_HYPER_ESPACE_BACKEND.post('/v2/simulate', newSimulatePrompt)
        .then((response) => {
          context.commit('setPromptSimulate', response.data.text)
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement de la simulation:', error.message)
          }
        })
        .finally(() => {
          context.commit('setLoadingPromptSimulate', false)
        })
    },
    addOrUpdatePrompt (context, prompt) {
      prompt.annonceurId = context.state.prompt.annonceurId

      // Forcer defaut en booléen
      prompt.defaut = Boolean(prompt.defaut)

      // Si datum est déjà un objet { id, champs }, on le garde tel quel
      // Sinon on crée la structure uniforme
      let datumStructure = null
      if (prompt.datum && typeof prompt.datum === 'object' && prompt.datum.champs) {
        datumStructure = prompt.datum // Déjà la bonne structure
      } else if (Array.isArray(prompt.datum)) {
        // Ancienne structure : transformer en { id, champs }
        datumStructure = { id: null, champs: prompt.datum }
      } else {
        datumStructure = null
      }

      const promptData = { ...prompt, datum: datumStructure }
      context.commit('setLoadingPrompt', true)

      // Utiliser PUT pour la mise à jour (si ID existe) et POST pour la création
      const httpMethod = promptData.id ? HTTP_HYPER_ESPACE_BACKEND.put : HTTP_HYPER_ESPACE_BACKEND.post
      httpMethod('/v2/add-or-update-prompt', promptData)
        .then((response) => {
          context.commit('addOrUpdateLibrary', promptData)
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement de la mise à jour du prompt ou de la création:', error.message)
          }
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
          if (!context.state.infos.diffuseurId) {
            context.dispatch('loadPrompts')
          } else {
            context.dispatch('loadLibraryPromptByDiffuseur', { annonceurId: context.state.infos.annonceurId, diffuseurId: context.state.infos.diffuseurId })
          }
        })
    },
    deletePrompt (context, prompt) {
      const deletedPrompt = prompt
      const uri = `/v2/delete-prompt/${deletedPrompt.id}`
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.delete(uri)
        .then((response) => {
          context.commit('deletedPrompt', deletedPrompt)
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'test') {
            console.error('Erreur lors du chargement de la suppression du prompt:', error.message)
          }
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
          context.dispatch('loadPrompts')
        })
    },
    updatePromptDefault (context, prompt) {
      prompt.defaut = true
      context.dispatch('addOrUpdatePrompt', prompt)
    },
    loadLibraryPromptByDiffuseur ({ state, commit, rootState }) {
      const sitimmoUser = rootState.app.sitimmoUser
      const diffuseurId = state.infos.diffuseurId
      const annonceurId = state.infos.annonceurId
      if (diffuseurId && (sitimmoUser.optionIa && sitimmoUser.personnalisationPrompts)) {
        commit('setLoadingPrompt', true)
        HTTP_HYPER_ESPACE_BACKEND
          .get(`/v2/get-prompts?annonceurId=${annonceurId}&diffuseurId=${diffuseurId}`)
        // TODO: .get(`/get-prompts?annonceurId=${annonceurId}&diffuseurId=${diffuseurId}`)
          .then((response) => {
            commit('resetLibrariePrompts', response.data)
          })
          .catch((error) => {
            if (process.env.NODE_ENV !== 'test') {
              console.error('Erreur lors du chargement du chargement de la librairie de prompts par diffuseur:', error.message)
            }
          })
          .finally(() => {
            commit('setLoadingPrompt', false)
          })
      }
    },
    findPromptAndSend ({ state, commit, dispatch, rootState }, { promptId, diffuseurName, post, isNeedSocialNetwork }) {
      const prompts = state.librariePrompt.prompts
      const indexPromptInStore = prompts.findIndex((prompt) => prompt.id === promptId)

      if (indexPromptInStore > -1 && prompts[indexPromptInStore] !== undefined && prompts[indexPromptInStore].diffuseurId === -1) {
        commit('setLoadingPrompt', true)
        // const url = `/diffuseurs?diffuseur=${diffuseurName}`
        const url = `/v2/diffuseurs?diffuseur=${diffuseurName}`
        HTTP_HYPER_ESPACE_BACKEND.get(url)
          .then((response) => {
            prompts[indexPromptInStore].diffuseurId = response.data
          }).catch((error) => {
            if (process.env.NODE_ENV !== 'test') {
              console.error('Erreur lors du chargement de la restitution de la liste des prompts par diffuseur:', error.message)
            }
          }).finally(() => {
            commit('setLoadingPrompt', false)
          })
      }

      if (diffuseurName && promptId) {
        let diffuseur = diffuseurName.split('_')[0]
        if (diffuseur === 'GOOGLE') {
          diffuseur = 'GMB'
        }
        if (!post.post_ia_prompt_custom) {
          post.post_ia_prompt_custom = {}
        }

        if (post.post_ia_prompt_custom[`${diffuseur}`]) {
          // Mise à jour du diffuseur existant
          post.post_ia_prompt_custom[`${diffuseur}`] = { ...post.post_ia_prompt_custom[`${diffuseur}`], ...{ prompt_id: promptId } }
        } else {
          // Ajout d'un nouveau diffuseur
          post.post_ia_prompt_custom[`${diffuseur}`] = { prompt_id: promptId }
        }
        const universe = post.univers
          || (post.advertiser && post.advertiser.universeCode)
          || (rootState.app.sitimmoUser && rootState.app.sitimmoUser.univers)
        const fluxEmission = post.emission
          || (post.sourceCode ? { codeName: post.sourceCode } : null)
        const data = {
          annonceur: {
            login: post.advertiser.login
          },
          ...buildSocialNetworkPatchPayload(universe, isNeedSocialNetwork, fluxEmission),
          annonce: {
            post_ia_prompt_custom: post.post_ia_prompt_custom
          }
        }

        HTTP_HYPER_ESPACE_BACKEND.patch(`/annonce/${post.id}`, data)
          .then(response => {
            if (response.status === 200) {
              dispatch('caption/loadCaptionsWithPromptLibrairies', { data: response.data.ad, diffuseurName: diffuseurName }, { root: true })
            }
          }).catch(error => {
            return { type: 'error', message: error }
          })
      }
    }
  }
}
